var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F6A723"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 22C13.0665 22 11.3166 21.2165 10.0498 19.9498L14.9995 15V8C18.8655 8 21.9995 11.134 21.9995 15C21.9995 18.866 18.8655 22 14.9995 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.999 14.9995C25.999 21.0746 21.0741 25.9995 14.999 25.9995C8.92389 25.9995 3.99902 21.0746 3.99902 14.9995C3.99902 8.92438 8.92389 3.99951 14.999 3.99951C21.0741 3.99951 25.999 8.92438 25.999 14.9995ZM23.999 14.9995C23.999 19.9701 19.9696 23.9995 14.999 23.9995C10.0285 23.9995 5.99902 19.9701 5.99902 14.9995C5.99902 10.029 10.0285 5.99951 14.999 5.99951C19.9696 5.99951 23.999 10.029 23.999 14.9995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayIcon);
export default __webpack_public_path__ + "static/media/DelayIcon.9df53d16da4d49566049356eb551786d.svg";
export { ForwardRef as ReactComponent };